import { render, staticRenderFns } from "./BillyIVA.vue?vue&type=template&id=f477acf2&scoped=true&"
import script from "./BillyIVA.vue?vue&type=script&lang=js&"
export * from "./BillyIVA.vue?vue&type=script&lang=js&"
import style0 from "./BillyIVA.vue?vue&type=style&index=0&id=f477acf2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f477acf2",
  null
  
)

export default component.exports